/*
 * KAS LUXURY — three things traxnyc.com does that we did not.
 *
 * Benchmarked 9-10 Oct 2026. They are a Shopify store on a custom theme, so none of this
 * was a platform advantage. All three use data KAS already holds and simply never showed.
 *
 * ONE — SPEC ROWS UNDER THE PRICE.
 * Their chain page answers the buyer's questions before any selector: "10K Gold, 41.7%
 * Pure Gold", "11 Grams (approx.)", "4.6mm Wide", "22 Inches". Ours had the same facts,
 * collapsed inside an accordion and repeated again in a tab below the fold. These lift
 * them to where the decision is made, and the metal and weight rows follow the metal the
 * customer picks, exactly as theirs follow the length.
 *
 * TWO — WHO IS SELLING, AND ON WHAT TERMS, BESIDE THE BUTTON.
 * Theirs reads "Sold by TraxNYC, 64 W 47th St, New York, since 2004", with returns and
 * what is in the box. For an unknown Bangkok business asking four figures of a stranger,
 * this is the cheapest trust on the page. Every line here is a fact KAS can stand behind.
 * Nothing is invented and NO REVIEW OR RATING IS IMPLIED -- there are none yet, and a
 * fabricated one would be worse than none.
 *
 * THREE — PRICE AND COUNT ON EVERY CATEGORY TILE.
 * Their row reads "GOLD CHAINS from $500" and "PENDANTS from $150, 2,368 pieces". Ours
 * said only RINGS. A shopper cannot tell whether a category is worth a click without
 * knowing what it costs and how much is in it. Both figures are read live from the
 * collection, so neither can go stale.
 *
 * WHY text() INSERTS A PIPE BETWEEN BLOCKS, WHICH LOOKS ODD AND IS NOT:
 * taking .textContent of the description runs every paragraph together with no gap, so
 * "Colour & clarity: F-G, VS1-VS2" followed by "Made to order in 4-5 weeks." became one
 * run of characters with a single full stop at the very end. A field pattern that stops
 * at a full stop then swallowed the next paragraph whole, and the spec row read
 * "F-G, VS1-VS2 Made to order in 4-5 weeks". Marking the block boundaries first gives
 * every field a hard end. Caught on the live preview, not in review.
 *
 * FAIL-SAFE THROUGHOUT: a missing fact renders nothing rather than an empty row or the
 * word "undefined". A product with no stated carat weight simply gets fewer rows.
 *
 * NO BACKSLASHES IN THIS FILE -- see the note in kas-ring-size.js.
 */
(function () {
  'use strict';

  var PURITY = { '10KT Gold': '41.7% pure gold', '14KT Gold': '58.3% pure gold',
                 '18KT Gold': '75% pure gold', 'Platinum': '95% platinum' };
  var WKEY = { '10KT Gold': '10KT', '14KT Gold': '14KT', '18KT Gold': '18KT',
               'Platinum': 'platinum' };

  function text(html) {
    var d = document.createElement('div');
    d.innerHTML = String(html || '').replace(/<[/](p|div|li|h[1-6]|br)[ ]*>/gi, ' | ')
                                    .replace(/<br[ ]*[/]?>/gi, ' | ');
    return (d.textContent || '').replace(/[ ]+/g, ' ');
  }

  // Fields end at a full stop OR a block boundary, never at the next paragraph.
  function grab(pattern, s) {
    var m = s.match(pattern);
    if (!m) return null;
    return m[1].replace(/[|]/g, ' ').trim().replace(/[,;]$/, '') || null;
  }

  function findSelect(name) {
    var all = document.querySelectorAll('select');
    for (var i = 0; i < all.length; i++) {
      if (all[i].name === name) return all[i];
    }
    return null;
  }

  function row(parent, label, value) {
    var d = document.createElement('div');
    d.className = 'kas-spec';
    var a = document.createElement('span');
    a.className = 'kas-spec__label';
    a.textContent = label;
    var b = document.createElement('span');
    b.className = 'kas-spec__value';
    b.textContent = value;
    d.appendChild(a);
    d.appendChild(b);
    parent.appendChild(d);
  }

  // ---------------------------------------------------------------- one: spec rows
  function specs(product) {
    var host = document.querySelector('.product__block--product-header');
    if (!host || document.getElementById('kas-specs')) return null;
    var s = text(product.description);

    var centre = grab(/Cent[re]{2}[ ]*stone:[ ]*([0-9.]+[ ]*ct[ ]*[a-zA-Z- ]*)/i, s) ||
                 grab(/Center[ ]*stone:[ ]*([0-9.]+[ ]*ct[ ]*[a-zA-Z- ]*)/i, s);
    var total = grab(/Diamonds?:[ ]*Lab-grown,[ ]*([0-9.]+[ ]*ct)[ ]*total/i, s);
    var gem = grab(/Gemstone:[ ]*([^.|]+)/i, s);
    var clarity = grab(/Colou?r[ ]*&[ ]*clarity:[ ]*([^.|]+)/i, s);
    var cert = grab(/Certification:[ ]*([^.|]+)/i, s);

    var weights = {};
    var re = /([0-9.]+)[ ]*g[ ]*in[ ]*(10KT|14KT|18KT|platinum)/gi;
    var m;
    while ((m = re.exec(s)) !== null) {
      var k = m[2].toLowerCase() === 'platinum' ? 'platinum' : m[2].toUpperCase();
      weights[k] = m[1];
    }
    var m14 = s.match(/Piece[ ]*weight:[ ]*([0-9.]+)[ ]*g[ ]*in[ ]*14KT/i);
    if (m14) weights['14KT'] = m14[1];

    var wrap = document.createElement('div');
    wrap.id = 'kas-specs';
    wrap.className = 'kas-specs';
    host.parentNode.insertBefore(wrap, host.nextSibling);

    function render() {
      var metal = (findSelect('options[Metal]') || {}).value;
      wrap.innerHTML = '';
      if (centre) row(wrap, 'Centre stone', centre);
      if (total) row(wrap, 'Diamonds', total + ' total, lab grown');
      if (gem) row(wrap, 'Gemstone', gem);
      if (metal) {
        row(wrap, 'Metal', metal.replace(' Gold', ' gold') +
            (PURITY[metal] ? ', ' + PURITY[metal] : ''));
        var w = weights[WKEY[metal]];
        if (w) row(wrap, 'Weight', w + ' g approx.');
      }
      if (clarity) row(wrap, 'Colour & clarity', clarity);
      if (cert) row(wrap, 'Certification', cert);
    }
    render();
    return render;
  }

  // ---------------------------------------------------------------- two: who is selling
  function soldBy(product) {
    if (document.getElementById('kas-soldby')) return;
    var anchor = document.getElementById('kas-ask-jeweller') ||
                 document.querySelector('form[action*="/cart/add"]');
    if (!anchor || !anchor.parentNode) return;
    var cert = grab(/Certification:[ ]*([^.|]+)/i, text(product.description));

    var rows = [
      ['Made by', 'KAS Luxury, in our own factory in the Gems Tower, Bangkok, since 2022'],
      ['Made to order', 'Four to five weeks. If yours is already finished we will tell you sooner'],
      ['Shipping', 'Insured and tracked worldwide, three to six days once it is ready. Duties are payable on arrival']
    ];
    if (cert) rows.push(['In the box', cert]);
    rows.push(['Returns', 'A ready-made piece comes back under our satisfaction guarantee. A piece made to your size comes back for a fault or a mistake on our side']);

    var dl = document.createElement('dl');
    dl.id = 'kas-soldby';
    dl.className = 'kas-soldby';
    rows.forEach(function (r) {
      var dt = document.createElement('dt');
      dt.textContent = r[0];
      var dd = document.createElement('dd');
      dd.textContent = r[1];
      dl.appendChild(dt);
      dl.appendChild(dd);
    });
    anchor.parentNode.insertBefore(dl, anchor.nextSibling);
  }

  // ---------------------------------------------------------------- three: category tiles
  function money(n, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: currency || 'USD', maximumFractionDigits: 0
      }).format(n);
    } catch (e) { return '$' + Math.round(n); }
  }

  function categories() {
    var tiles = document.querySelectorAll('a.kas-dark-category');
    if (!tiles.length) return;
    var currency = (window.Shopify && window.Shopify.currency &&
                    window.Shopify.currency.active) || 'USD';
    Array.prototype.forEach.call(tiles, function (a) {
      var m = (a.getAttribute('href') || '').match(/[/]collections[/]([^/?#]+)/);
      if (!m || a.querySelector('.kas-cat-stat')) return;
      fetch('/collections/' + m[1] + '/products.json?limit=250', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.products || !d.products.length) return;
          var lowest = null;
          d.products.forEach(function (p) {
            (p.variants || []).forEach(function (v) {
              var val = parseFloat(v.price);
              if (!isNaN(val) && val > 0 && (lowest === null || val < lowest)) lowest = val;
            });
          });
          if (lowest === null) return;
          var n = d.products.length;
          var el = document.createElement('span');
          el.className = 'kas-cat-stat';
          el.textContent = 'from ' + money(lowest, currency) + '  ·  ' + n +
                           (n === 1 ? ' piece' : ' pieces');
          a.appendChild(el);
        })
        .catch(function () { /* a tile without a figure is still a working tile */ });
    });
  }

  // ---------------------------------------------------------------- wiring
  function start() {
    categories();
    var m = window.location.pathname.match(/[/]products[/]([^/?#]+)/);
    if (!m) return;
    fetch('/products/' + m[1] + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (!product) return;
        var rerender = specs(product);
        soldBy(product);
        if (rerender) {
          document.addEventListener('change', function (e) {
            if (e.target && e.target.tagName === 'SELECT') setTimeout(rerender, 60);
          }, true);
        }
      })
      .catch(function () { /* never break a page over a decoration */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());